interface RaiseDisputeDeductionDTOProps {
  deductionId: number;
  disputeTypeId: number;
  disputeSubTypeId?: number;
  disputeAmount: number;
  totalAmount: number;
  contactInfo?: {
    name: string;
    email: string;
  };
  disputeRequestMessage: string;
  documentIds?: number[] | null;
  portalKey: string;
  poNumber?: string;
  checkNumber?: string;
  invoiceNumber?: string;
  brandName?: string;
  vendorNumber?: string;
  distributionCenter?: string;
  dataProviderType?: string;
  deductionTypeId: number;
  remittanceItemId: number;
  purchaserId: number;
  purchaserKey: string;
}

export class RaiseDisputeDeductionDTO {
  readonly deductionId: number;

  readonly disputeTypeId: number;

  readonly disputeSubTypeId?: number;

  readonly disputeAmount: number;

  readonly totalAmount: number;

  readonly contactInfo?: {
    name: string;
    email: string;
  };

  readonly portalKey: string;

  readonly disputeRequestMessage: string;

  readonly documentIds?: number[] | null;

  readonly poNumber?: string;
  readonly checkNumber?: string;
  readonly invoiceNumber?: string;
  readonly brandName?: string;
  readonly vendorNumber?: string;
  readonly distributionCenter?: string;
  readonly dataProviderType?: string;
  readonly deductionTypeId: number;
  readonly remittanceItemId: number;
  readonly purchaserId: number;
  readonly purchaserKey: string;



  constructor(data: RaiseDisputeDeductionDTOProps) {
    this.deductionId = data.deductionId;
    this.disputeTypeId = data.disputeTypeId;
    this.disputeSubTypeId = data.disputeSubTypeId;
    this.disputeAmount = data.disputeAmount;
    this.totalAmount = data.totalAmount;
    this.contactInfo = data.contactInfo;
    this.disputeRequestMessage = data.disputeRequestMessage;
    this.documentIds = data.documentIds;
    this.portalKey = data.portalKey;
    this.poNumber = data.poNumber;
    this.checkNumber = data.checkNumber;
    this.invoiceNumber = data.invoiceNumber;
    this.brandName = data.brandName;
    this.vendorNumber = data.vendorNumber;
    this.distributionCenter = data.distributionCenter;
    this.dataProviderType = data.dataProviderType;
    this.deductionTypeId = data.deductionTypeId;
    this.remittanceItemId = data.remittanceItemId;
    this.purchaserId = data.purchaserId;
    this.purchaserKey = data.purchaserKey;
  }
}
